export const initialState = {
  loading: false,
  users: {},
  apiStatus: {
    loader: false,
    message: null,
    next: false,
    data: null,
    uploadPdf: [],
    apiError: false,
    apiSuccess: false,
  },
};
